// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__NM-AP","row":"styles_row__9q3GN","col":"styles_col__kb1v6"};